import { inputTypes } from 'components/common/FormElements/Input'
import { LOCATION_FINDER_INPUT, LOCATION_FINDER_HINT_ID } from 'constant'

export default ({
  addressSuggestions,
  stateOptions = [],
  resetAddresses
} = {}) => ({
  locationSearch: {
    name: LOCATION_FINDER_INPUT,
    label: 'City/State OR Zip',
    inputType: inputTypes.REACT_AUTOSUGGEST_INPUT,
    onSuggestionsClearRequested: resetAddresses,
    suggestions: addressSuggestions,
    required: true,
    'aria-describedby': LOCATION_FINDER_HINT_ID
  }
})
